import { Option } from "@platform/design-system";
import { useMemo } from "react";

import { useRfpFinalDecisionCarriers } from "../../../../hooks/useRfpFinalDecisionCarriers";
import { Carrier } from "../../../../types/rfpApi";

interface UseGetCarriersResponse {
  carriers: Option[];
  carrierMap: Map<number, Carrier>;
  isLoading?: boolean;
}

const useGetCarriers = (rfpId: string): UseGetCarriersResponse => {
  const { data: rfpCarriers, isLoading } = useRfpFinalDecisionCarriers({
    rfpId,
  });

  const { carrierMap, carriers } = useMemo(() => {
    const carrierMap = new Map<number, Carrier>();
    const carriers: Option[] = [];
    rfpCarriers?.forEach((carrier) => {
      carrierMap.set(carrier.id, carrier);
      carriers.push({ label: carrier.name, value: carrier.id });
    });
    return { carrierMap, carriers };
  }, [rfpCarriers]);

  return { carrierMap, carriers, isLoading };
};

export { useGetCarriers };
